import auth from '@groovepages/gd-lib/auth';
import jsSHA from "jssha";

export const ucfirst = function(str) {
  const firstLetter = str.substr(0, 1);
  return firstLetter.toUpperCase() + str.substr(1);
};

// Helper for URL generator
function hex2a(hexx) {
  var hex = hexx.toString() //force conversion
  var str = ''
  for (var i = 0; i < hex.length; i += 2)
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
  return str
}

export function isNotAllowedForImgproxy(file) {
  return file.split('.').pop() === 'svg' || file.split('.').pop() === 'gif';
}

// URL generator logic
export function gdImgProxy(opts) {
  if( isNotAllowedForImgproxy(opts.url) )
    return opts.url;
  
  const defaultOpts = {
    key : '81ff5a91d621d4359769be440e98d714d2f867ab2470ce85765b9246d9c01d95',
    salt: '0c941964cc1bc5433d821d866759e1399e297076cf6c99e1c673f940dbdd0d38',
    proxy_url : 'https://images.groovetech.io',
    //--
    url : '',
    height : 0,
    width : 0,
    resize : 'fit',
    gravity : 'no',
    gravity_offset_x : 0,
    gravity_offset_y : 0,
    crop_width: 0,
    crop_height: 0,
    extension : 'webp',
    enlarge : 0
  }

  opts = {...defaultOpts,...opts};
  
  var encoded_url = btoa(unescape(encodeURIComponent(opts.url))).replace(/=/g, "").replace(/\//g, '_').replace(/\+/g, '-')

  var path =  `/rs:${opts.resize}:${opts.width}:${opts.height}:${opts.enlarge}`; // Resize settings
      path += `/g:${opts.gravity}:${opts.gravity_offset_x}:${opts.gravity_offset_y}`; // Gravity settings
      path += `/c:${opts.crop_width}:${opts.crop_height}`; // Crop settings
      path += `/${encoded_url}.${opts.extension}`;

  var shaObj = new jsSHA("SHA-256", "BYTES")
  shaObj.setHMACKey(opts.key, "HEX")
  shaObj.update(hex2a(opts.salt))
  shaObj.update(path)
  var hmac = shaObj.getHMAC("B64").replace(/=/g, "").replace(/\//g, '_').replace(/\+/g, '-')
  return opts.proxy_url + "/" + hmac + path
}

export const animationsIn = ["bounce","flash","pulse","rubberBand","shakeX","shakeY","headShake","swing","tada","wobble","jello","heartBeat","bounceIn","bounceInDown","bounceInLeft","bounceInRight","bounceInUp","fadeIn","fadeInDown","fadeInDownBig","fadeInLeft","fadeInLeftBig","fadeInRight","fadeInRightBig","fadeInUp","fadeInUpBig","fadeInTopLeft","fadeInTopRight","fadeInBottomLeft","fadeInBottomRight","flip","flipInX","flipInY","rotateIn","rotateInDownLeft","rotateInDownRight","rotateInUpLeft","rotateInUpRight","jackInTheBox","rollIn","zoomIn","zoomInDown","zoomInLeft","zoomInRight","zoomInUp","slideInDown","slideInLeft","slideInRight","slideInUp"];
export const animationsOut = ["bounceOut","bounceOutDown","bounceOutLeft","bounceOutRight","bounceOutUp","fadeOut","fadeOutDown","fadeOutDownBig","fadeOutLeft","fadeOutLeftBig","fadeOutRight","fadeOutRightBig","fadeOutUp","fadeOutUpBig","fadeOutTopLeft","fadeOutTopRight","fadeOutBottomRight","fadeOutBottomLeft","flipOutX","flipOutY","rollOut","zoomOut","zoomOutDown","zoomOutLeft","zoomOutRight","zoomOutUp","slideOutDown","slideOutLeft","slideOutRight","slideOutUp"];

// User Region
let user = auth.authenticatedUser();
let region = user?.metadata?.region;
export const userRegion = region;

export function getStoryArgs(control, description, defaultValue, options) {
  const fields = {};
  if (control) fields.control = control;
  if (description) fields.description = description;
  if (defaultValue) fields.table = { defaultValue: { summary: defaultValue } };
  if (options) fields.options = options;
  return fields;
}